import {
  SET_LIST,
  SET_CHNL,
  SET_TOTAL,
  SET_OFFSET,
  SET_MAX,
  SET_SORT,
  SET_ORDER,
  CLEAR,
} from "./mutation-types";

export default {
  [SET_LIST](state, listItems) {
    state["whiteOrgs"] = [...listItems];
  },
  [SET_TOTAL](state, total) {
    state["total"] = total;
  },
  [SET_CHNL](state, chnl) {
    state["chnl"] = chnl;
  },
  [SET_OFFSET](state, offset) {
    state["offset"] = offset;
  },
  [SET_MAX](state, max) {
    state["max"] = max;
  },
  [SET_SORT](state, sort) {
    state["sort"] = sort;
  },
  [SET_ORDER](state, order) {
    state["order"] = order;
  },
  [CLEAR](state) {
    state["whiteOrgs"] = [];
    state["chnl"] = 0;
    state["total"] = 0;
    state["max"] = 10;
    state["offset"] = 0;
    state["sort"] = "organization.name";
    state["order"] = "ascending";
  },
};
